import { createSlice } from '@reduxjs/toolkit';
import { HttpMethod, sendError_notify } from '../../../Asset/httpMethod';
import { startLoader, stopLoader } from '../Utility/loaderSlice';
import { AlertPopup } from "../../../Asset/common";

export const WishListfetchData = () => async (dispatch) => {
  dispatch(startLoader())
  const res = await HttpMethod.get('/Stock/StockSearch/WishlistList');
  if (res?.status === 200) {
    dispatch(getData(await res.data));
  }
  dispatch(stopLoader())
};

export const WishListaddData = (data) => async (dispatch) => {
  dispatch(startLoader())
  const res = await HttpMethod.post('/Stock/StockSearch/AddToWishlist', data);
  if (res?.status === 200) {
    dispatch(WishListfetchData())
    AlertPopup.SuccessPopup(res.data);
  };
  dispatch(stopLoader())
}

export const WishListDelData = (data) => async (dispatch) => {
  dispatch(startLoader())
  const res = await HttpMethod.post('/Stock/StockSearch/RemoveWishlist', data);
  if (res?.status === 200) {
    dispatch(WishListfetchData())
    AlertPopup.SuccessPopup(res.data);
  }
  dispatch(stopLoader())
};

export const WishListSlice = createSlice({
  name: 'WishList',
  initialState: {
    "StockWishlistList": [],
    "StockWishlistList1": []
  },
  loading: false,
  reducers: {
    getData: (state, action) => {
      return { ...action.payload };
    }
  },
});
export const { getData } = WishListSlice.actions;
export default WishListSlice.reducer;